/**
 * Команда на Contact — видеовизитки и портреты.
 * Сюда класть имя, роль, photo и video.
 */

export const TEAM_COPY = {
    label: "Meet the team",
};

export const TEAM_MEMBERS = [
    {
        id: "dev-1",
        name: "Serhii Radziievskyi",
        role: "Full Stack Developer",
        photo: "/team/dev-1.jpg",
        video: "",
    },
    {
        id: "dev-2",
        name: "Roma Anime",
        role: "Software Developer",
        photo: "/team/dev-2.jpg",
        video: "",
    },
    {
        id: "dev-3",
        name: "Artem Khvyshchuk",
        role: "UI/UX & Motion Designer",
        photo: "/team/dev-3.jpg",
        video: "",
    },
];

// config/team.js
